import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _ from 'lodash';
import { Input } from 'semantic-ui-react';
import { ColorNames } from '../../../constants/colorVars';
import Icon from '../icon';
import classnames from 'classnames/bind';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const SearchFilter = ({ elmId = 'search_filter', onSearchIconClick = () => undefined, onResetIconClick, disabled, placeholder = 'Search...', onChange, onClick, value = '', inputRef, width, size = 'medium', }) => {
    const isEmpty = _.isEmpty(value);
    return (_jsxs("div", { className: cx('search-filter', { active: !isEmpty }, { 'fluid-width': width === 'fluid' }, {
            small: size === 'small',
            medium: size === 'medium',
        }), children: [_jsx(Input, { ref: inputRef, "data-elm-id": `${elmId}_input`, onChange: onChange, onClick: onClick, value: value, icon: {
                    name: 'search',
                    link: true,
                    onClick: onSearchIconClick,
                }, placeholder: placeholder, disabled: disabled, clearable: true, iconPosition: 'left' }), !isEmpty && (_jsx("div", { className: cx('reset-button'), onClick: onResetIconClick, children: _jsx(Icon, { className: cx('icon'), color: ColorNames.Action, iconStyle: 'solid', name: 'xmark', size: 'medium', fitted: true }) }))] }));
};
export default SearchFilter;
//# sourceMappingURL=index.js.map